module.exports = __webpack_public_path__ + "img/39.e433c0ef.jpg";